import AccessoriyDetail from "@/views/project/accessoriy/accessoriyDetail.vue";
import Compare from "@/views/project/compare.vue";
import Favorite from "@/views/project/favorite.vue";
import Forgotpwd from "@/views/project/forgotpwd.vue";
import ForkModel from "@/views/project/model/forkModel.vue";
import Quotation from "@/views/project/model/quotation.vue";
import RightMode from "@/views/project/model/rightMode.vue";
import Register from "@/views/project/register.vue";

export default {
  公司介绍: {
    公司介绍: "公司介绍",
    叉车租赁已达19年: "叉车租赁已达19年",
    我们提供: "我们提供",
    多样化的租赁模式: "多样化的租赁模式",
    完善的售后回租业务: "完善的售后回租业务",
    一体化的服务网络: "一体化的服务网络",
    专业化的服务团队: "专业化的服务团队",
    保障性的服务方案: "保障性的服务方案",
    叉车租赁: "叉车租赁",
    租赁模式: "租赁模式",
    不同规格: "不同规格",
    不同品牌: "不同品牌",
    多种类型: "多种类型",
    多款车型: "多款车型",
    "叉车载重从1吨-10吨不等,不同吨数可满足客户不同租赁要求":
      "叉车载重从1吨-10吨不等,不同吨数可满足客户不同租赁要求",
    "TOTOTA、BT、JUNGHEINRICH、NICHIYU等为我公司的战略":
      "TOTOTA、BT、JUNGHEINRICH、NICHIYU等为我公司的战略",
    电动叉车和柴油叉车为客户带来不同环境叉车租赁需求:
      "电动叉车和柴油叉车为客户带来不同环境叉车租赁需求",
    "仓储叉车，平衡重叉车，牵引车，前移式叉车，托盘车，拣选叉车等多种的叉车类型":
      "仓储叉车，平衡重叉车，牵引车，前移式叉车，托盘车，拣选叉车等多种的叉车类型",
    叉车租赁形式: "叉车租赁形式",
    服务体系: "服务体系",
    快速可靠: "快速可靠",
    专业化服务: "专业化服务",
    "4小时的及时响应": "4小时的及时响应",
    "48小时的换车服务": "48小时的换车服务",
    完善的服务网络: "完善的服务网络",
    专业叉车服务团队: "专业叉车服务团队",
    短期租赁服务: "短期租赁服务",
    "短期租赁可以按天，周，月计算": "短期租赁可以按天，周，月计算",
    中长期租赁服务: "中长期租赁服务",
    提供中长期租赁和短期租赁相结合的灵活租赁模式:
      "提供中长期租赁和短期租赁相结合的灵活租赁模式",
    融资性租赁服务: "融资性租赁服务",
    在租赁期满后设备产权自动转移给租赁客户:
      "在租赁期满后设备产权自动转移给租赁客户",
    大客户的灵活租赁: "大客户的灵活租赁",
    "提供叉车选型，叉车数量，叉车调配等方面的灵活组合":
      "提供叉车选型，叉车数量，叉车调配等方面的灵活组合",
    传统服务方案: "传统服务方案",
    人工全责服务: "人工全责服务",
    "特别推荐：全责服务": "特别推荐：全责服务",
  },
  联系我们: {
    销售团队: "销售团队",
    采购团队: "服务团队",
    主要销售地点: "主要销售地点",
    捷丰销售地点地址: "捷丰销售地点地址",
    在地图中显示: "在地图中显示",
    仓库面积达40000平方米: "仓库面积达40000平方米",
    核心仓库: "核心仓库",
    捷丰核心仓库地址: "捷丰核心仓库地址",
    "仓库距离货运公路2,000米": "仓库距离货运公路2,000米",
    其他: "其他",
    "捷丰林合工业设备(上海)有限公司": "捷丰林合工业设备(上海)有限公司",
    江苏省太仓市陆渡镇江南路81号丰田叉车:
      "江苏省太仓市双凤镇富豪经济开发区广州西路与204国道交汇处捷丰二手叉车中心",
    "统一社会信用代码：": "统一社会信用代码：",
    "销售服务热线:": "销售服务热线:",
    "开户行：": "开户行：",
    中国银行上海市宁虹路支行: "中国银行上海市宁虹路支行",
    "银行账号：": "银行账号：",
  },
  top: {
    库里的叉车: "库里的叉车",
    在途的叉车: "在途的叉车",
    叉车属具: "叉车属具",
    新闻中心: "新闻中心",
    公司介绍: "公司介绍",
    联系我们: "联系我们",
    电话: "电话",
    联系人姓名: "联系人姓名",
    收藏: "收藏",
    比较: "比较",
    登录: "登录",
    中文: "中文",
    英文: "英文",
    语言: "语言",
  },
  bottom: {
    "捷丰林合工业设备(上海)有限公司": "捷丰林合工业设备(上海)有限公司",
    江苏省太仓市陆渡镇江南路81号丰田叉车:
      "江苏省太仓市双凤镇富豪经济开发区广州西路与204国道交汇处捷丰二手叉车中心",
    "统一社会信用代码:91310120324706632P":
      "统一社会信用代码:91310120324706632P",
    企业网站: "企业网站:http://www.jfrental.com/",
    社交媒体: "社交媒体",
    相关社群: "相关社群",
    "隐私政策|版权所有©捷丰林合工业设备(上海)有限公司":
      "隐私政策|版权所有©捷丰林合工业设备(上海)有限公司",
  },
  库里的叉车: {
    重置筛选条件: "重置",
    模糊查询: "模糊查询",
    车辆品牌: "车辆品牌",
    车辆类型: "车辆类型",
    属具类型: "属具类型",
    动力方式: "动力方式",
    门架类型: "门架类型",
    载重能力: "载重能力",
    提升高度: "提升高度",
    叉车回落高度: "叉车回落高度",
    生产年份: "生产年份",
    工作小时数: "工作小时数",
    阀路: "阀路",
    其他: "其他",
    "+ 展开": "+ 展开",
    "- 收起": "- 收起",
  },
  车辆详情: {
    生产年份: "生产年份",
    动力方式: "动力方式",
    负载能力: "负载能力",
    提升高度: "提升高度",
    工作小时数: "工作小时数",
    登录后查询价格: "登录后查询价格",
    如需帮助请拨打: "如需帮助请拨打",
    查询: "查询",
    播放: "播放",
    分享: "分享",
    收藏: "收藏",
    比较: "比较",
    打印PDF: "打印PDF",
    下载图片: "下载图片",
    车辆参数: "车辆参数",
    登记号: "登记号",
    "负载能力 公斤": "负载能力 公斤",
    "提升高度 毫米": "提升高度 毫米",
    "叉车回落高度 毫米": "叉车回落高度 毫米",
    阀路: "阀路",
    动力方式: "动力方式",
    生产年份: "生产年份",
    叉车自重: "叉车自重",
    电池情况: "电池情况",
    入库时间: "入库时间",
    预计到货时间: "预计到货时间",
    车辆属性: "车辆属性",
    属具类型: "属具类型",
    车辆类型: "车辆类型",
    门架类型: "门架类型",
    车架号: "车架号",
    车辆牌照号: "车辆牌照号",
    工作小时数: "工作小时数",
    其他车辆: "其他车辆",
  },
  车辆详情页右侧: {
    登录后查询价格: "登录后查询价格",
    不含增值税价格: "不含增值税价格",
    查询: "查询",
    如需帮助请拨打: "如需帮助请拨打",
    "拨打电话 周一至周日": "拨打电话 周一至周日",
    人员姓名: "刘辉",
  },
  叉车属具详情: {
    品牌: "品牌",
    负载能力: "负载能力",
    重量: "重量",
    生产年份: "生产年份",
    在船上: "在船上",
    登录后查询价格: "登录后查询价格",
    查询: "查询",
    视频: "视频",
    需要帮助请联系: "需要帮助请联系",
    属具参数: "属具参数",
    登记号: "资产登记号",
    规格型号: "规格型号",
    属具类型: "属具类型",
    "负载能力 公斤": "负载能力 公斤",
    "提升高度 毫米": "提升高度 毫米",
    "建筑高度 毫米": "建筑高度 毫米",
    起重设备: "起重设备",
    驱动: "驱动",
    生产年份: "出厂年份",
    "重量 公斤": "重量 公斤",
    电池: "电池",
    技术状态: "技术状态",
    功能的: "功能的",
    前轮: "前轮",
    后轮: "后轮",
    位置: "位置",
    属具属性: "属具属性",
    其他属具: "其他属具",
  },
  叉车属具: {
    设备类型: "设备类型",
    负载能力: "负载能力",
    从: "从",
    到: "到",
    品牌: "品牌",
    在船上: "在船上",
    搜索: "搜索",
    条件重置: "条件重置",
  },
  新闻明细: {
    点赞: "点赞",
    浏览: "浏览",
    本文标签: "本文标签",
    浏览次数: "浏览次数",
    次浏览: "次浏览",
    发布日期: "发布日期",
  },
  新闻中心: {
    新闻中心: "新闻中心",
    点赞: "点赞",
    浏览: "浏览",
  },
  accessoriyDetail: {
    品牌: "品牌",
    重量: "重量",
    生产年份: "生产年份",
    在船上: "在船上",
    登录后查询价格: "登录后查询价格",
    详情: "详情",
    询价: "询价",
  },
  accessoriyList: {
    品牌: "品牌",
    请选择: "请选择",
    按照车架号和车辆型号模糊搜索: "按照车架号和车辆型号模糊搜索",
  },
  quotation: {
    设备询价单: "设备询价单",
    现在询问底价: "现在询问底价",
    删除: "删除",
    公司名称: "公司名称",
    您的姓名: "您的姓名",
    电子邮箱: "电子邮箱",
    联系电话: "联系电话",
    询问内容: "询问内容",
  },
  forkmodel: {
    新引进的: "新引进的",
    登录后查询价格: "登录后查询价格",
    详情: "详情",
    询价: "询价",
  },
  compare: {
    对比装卸车: "对比装卸车",
    导出PDF: "导出PDF",
    全部删除: "全部删除",
    询价所有装卸车: "询价所有装卸车",
    删除: "删除",
    "生产商 型号": "生产商 型号",
    价格: "价格",
    "负载能力 公斤": "负载能力 公斤",
    "升降 毫米": "升降 毫米",
    "叉车回落高度 毫米": "叉车回落高度 毫米",
    动力方式: "动力方式",
    阀路: "阀路",
    电池情况: "电池情况",
    生产年份: "生产年份",
    工作小时数: "工作小时数",
    叉车自重: "叉车自重",
    属具类型: "属具类型",
    门架类型: "门架类型",
    查询: "查询",
    询价: "询价",
    全部删除: "全部删除",
    询价所有装卸车: "询价所有装卸车",
  },
  favorite: {
    停车场: "停车场",
    导出PDF: "导出PDF",
    全部删除: "全部删除",
    询价所有装卸车: "询价所有装卸车",
  },
  forgotpwd: {
    忘记密码: "忘记密码",
    发送: "发送",
    密码发邮件:
      "如果您忘记了密码，请填写下您的登录邮箱。稍后我们将向您发送一个链接，以创建此电子邮件的新密码。",
  },
  login: {
    立即注册: "立即注册",
    密码: "密码",
    登录: "登录",
    忘记密码: "忘记密码",
    库存超1500台叉车: "库存超1500台叉车",
    超值折扣: "超值折扣",
    快速交付: "快速交付",
    仅限叉车经销商使用: "仅限叉车经销商使用",
    电子邮箱: "电子邮箱",
    请填写您的Email: "请填写您的Email",
    请填写您的密码: "请填写您的密码",
    请输入您的邮箱: "请输入您的邮箱",
    请输入密码: "请输入密码",
  },
  register: {
    注册: "注册",
    登录信息: "登录信息",
    联系方式: "联系方式",
    公司信息: "公司信息",
    发票地址: "发票地址",
    其他: "其他",
    你想收到时事通讯吗: "你想收到时事通讯吗",
    发送新购买的叉车吗: "发送新购买的叉车吗",
    发送注册请求: "发送注册请求",
    请输入您的邮箱: "请输入您的邮箱",
    请输入密码: "请输入密码",
    电子邮箱: "电子邮箱",
    密码: "密码",
    确认密码: "确认密码",
    姓名: "姓名",
    公司名称: "公司名称",
    联系电话: "联系电话",
    街道和门牌号码: "街道和门牌号码",
    城市: "城市",
    邮编: "邮编",
    请选择国家: "请选择国家",
    请输入确认密码: "请输入确认密码",
    请输入姓名: "请输入姓名",
    请填写公司名称: "请填写公司名称",
    请填写手机号码: "请填写手机号码",
    请填写街道和门牌号码: "请填写街道和门牌号码",
    请填写城市: "请填写城市",
    请输入邮政编码: "请输入邮政编码",
    请选择国家: "请选择国家",
    中国: "中国",
    英国: "英国",
    俄罗斯: "俄罗斯",
    西班牙: "西班牙",
    日本: "日本",
  },
  userinfo: {
    我的账户: "我的账户",
    账户设置: "账户设置",
    注销: "注销",
  },
};
